module.exports = __webpack_public_path__ + "static/parade-2020-house55-41bc064f38a69432a593a2ec40fc071d.jpg";